import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCustomerNotificationsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-customer-notifications',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications',
};
